module.exports = __webpack_public_path__ + "static/media/ethan.0a018520.jpg";